module.exports = __webpack_public_path__ + "img/water-softener.c9990eea.svg";